export default __webpack_public_path__ + "static/media/apr2024-2.f401c6cc.jpg";